import { render, staticRenderFns } from "./suDetailReportListUdi.vue?vue&type=template&id=ab55ec74"
import script from "./suDetailReportListUdi.vue?vue&type=script&lang=js"
export * from "./suDetailReportListUdi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports